import React, {useEffect, useRef} from 'react'
import PropTypes from 'prop-types'
import {useForm} from 'react-hook-form'
import {useIntl} from 'react-intl'
import {useGoogleMapsApiLoader} from '../../google-maps-api'
import {useToast} from '../../hooks/use-toast'
import useMultiSite from '../../hooks/use-multi-site'
import {STORE_LOCATOR_HREF} from '../../constants'
import FindStoreFields from './find-store-fields'
import {fillMissingCoordinates} from '../../utils/utils'

const FindStoreLink = ({prefix = '', addressFieldId, inputProps, onSubmit, onError, formLabel}) => {
    const form = useForm()
    const intl = useIntl()
    const showToast = useToast()
    const mounted = useRef(true)
    const {buildUrl} = useMultiSite()
    const getGoogleMapsAPI = useGoogleMapsApiLoader()

    useEffect(() => {
        return () => {
            mounted.current = false
        }
    }, [])

    onError =
        onError ||
        (() => {
            showToast({
                title: intl.formatMessage({
                    id: 'find_store_link.error.title',
                    defaultMessage: 'Error obtaining location'
                }),
                status: 'error'
            })
        })

    onSubmit =
        onSubmit ||
        (async (data) => {
            try {
                const completedData = await fillMissingCoordinates(data, getGoogleMapsAPI)
                if (mounted.current) {
                    location.href = `${buildUrl(STORE_LOCATOR_HREF)}?${new URLSearchParams(
                        completedData
                    )}`
                }
            } catch (e) {
                onError(e)
            }
        })

    return (
        <form onSubmit={form.handleSubmit(onSubmit)} noValidate>
            <FindStoreFields
                form={form}
                inputProps={inputProps}
                prefix={prefix}
                onLocationChange={form.handleSubmit(onSubmit)}
                onError={onError}
                addressFieldId={addressFieldId}
                formLabel={formLabel}
                onSubmit={onSubmit}
            />
        </form>
    )
}

FindStoreLink.propTypes = {
    /** Optional input props to pass to the address field */
    inputProps: PropTypes.object,
    /** Optional prefix for field names */
    prefix: PropTypes.string,
    /** Function to call when form is submitted */
    onSubmit: PropTypes.func,
    /** Function to call when error occurs */
    onError: PropTypes.func,
    addressFieldId: PropTypes.string,
    formLabel: PropTypes.object
}

export default FindStoreLink
